import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(
  inputAnatomy.keys,
);

const fieldBase = {
  bg: 'bg.input',
  color: 'text.primary',
  borderColor: 'border.muted',
  borderRadius: 'md',
  transitionProperty: 'common',
  transitionDuration: 'normal',
  // Ensure at least 16px font-size to prevent iOS Safari from auto-zooming inputs on focus
  fontSize: '16px',
  _placeholder: {
    color: 'text.placeholder',
  },
  _hover: {
    borderColor: 'border.emphasized',
    bg: 'bg.input',
  },
  _focusVisible: {
    borderColor: 'accent.default',
    boxShadow: '0 0 0 1px var(--chakra-colors-accent-default)',
    bg: 'bg.input',
  },
  _invalid: {
    borderColor: 'critical.text',
    boxShadow: '0 0 0 1px var(--chakra-colors-critical-text)',
  },
  _disabled: {
    opacity: 1,
    bg: 'bg.disabled',
    color: 'text.muted',
    cursor: 'not-allowed',
    borderColor: 'border.muted',
    _placeholder: {
      color: 'text.muted',
    },
  },
};

const addonBase = {
  bg: 'bg.subtle',
  color: 'text.muted',
  borderColor: 'border.muted',
  borderRadius: 'md',
  transitionProperty: 'common',
  transitionDuration: 'normal',
};

const outline = definePartsStyle({
  field: fieldBase,
  addon: addonBase,
});

export const Input = defineMultiStyleConfig({
  variants: { outline },
  defaultProps: {
    variant: 'outline',
    size: 'md',
  },
});
